import { TotemInput } from 'components/TotemInput';
import { TotemPopup } from 'components/TotemPopup';
import { TotemPrimaryButton } from 'components/TotemPrimaryButton';
import { TotemSelect } from 'components/TotemSelect';
import { useGetProductArrangementsQuery } from 'data/__generated__';
import { FunctionComponent, useState } from 'react';
import styled from 'styled-components';
import { ArrangementSelection } from '../ProductArrangementCreationSection';

type AddArrangementPopupForCreationProps = {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    alreadySelectedIds: string[];
    onAdd: (arrangement: ArrangementSelection) => void;
};

export const AddArrangementPopupForCreation: FunctionComponent<AddArrangementPopupForCreationProps> = ({
    isOpen,
    setIsOpen,
    alreadySelectedIds,
    onAdd,
}) => {
    const { data } = useGetProductArrangementsQuery();

    const [selectedProductArrangementId, setSelectedProductArrangementId] = useState<string | null>(null);
    const [stockMax, setStockMax] = useState<number | null>(null);

    if (!data?.productArrangementsQuery) {
        return null;
    }

    const allOptions = data.productArrangementsQuery.map((pa) => ({ label: pa.name, value: pa._id }));
    const options = allOptions.filter((option) => !alreadySelectedIds.includes(option.value));

    const selectedOption = options.find((option) => option.value === selectedProductArrangementId);
    const selectedProductArrangement = data.productArrangementsQuery.find(
        (pa) => pa._id === selectedProductArrangementId,
    );

    const resetForm = () => {
        setSelectedProductArrangementId(null);
        setStockMax(null);
    };

    const onSubmit = () => {
        if (!selectedProductArrangementId || !selectedProductArrangement) {
            return;
        }

        onAdd({
            arrangementId: selectedProductArrangementId,
            arrangementName: selectedProductArrangement.name,
            stockMax: stockMax ?? 0,
        });

        resetForm();
        setIsOpen(false);
    };

    const handleClose = (open: boolean) => {
        if (!open) {
            resetForm();
        }
        setIsOpen(open);
    };

    return (
        <TotemPopup isOpen={isOpen} setIsOpen={handleClose} title="Ajouter à une gamme de produit">
            <Container>
                <TotemSelect
                    label="Gamme de produit"
                    options={options}
                    value={selectedProductArrangementId}
                    onChange={(value) => {
                        setSelectedProductArrangementId(value);
                        const pa = data.productArrangementsQuery.find((el) => el._id === value);
                        setStockMax(pa?.defaultStockMax ?? null);
                    }}
                />
                {selectedOption && (
                    <TotemInput
                        label="Stock max"
                        type="number"
                        onChange={(value) => {
                            const parsedValue = parseInt(value, 10);
                            setStockMax(parsedValue);
                        }}
                        value={stockMax ?? undefined}
                    />
                )}
                <TotemPrimaryButton onClick={onSubmit} disabled={!selectedProductArrangementId || stockMax === null}>
                    Ajouter
                </TotemPrimaryButton>
            </Container>
        </TotemPopup>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;
